import React, { useState } from 'react';
import PropTypes from 'prop-types';
import apiCalls from '../utils/apiCalls';
import utils from '../utils/utils';
import Loader from '../components/loader';
import ErrorMessage from '../components/errorMessage';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faList } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import DATE_FORMAT from '../components/constants/dateFormat';

const MarketplaceAdminCombinedOrderItems = ({
  marketplace,
  deliveryDayMarketplaces,
  pastDeliveryDayMarketplaces,
  match,
}) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [combinedOrderItems, setCombinedOrderItems] = useState([]);
  const [selectedDeliveryDayMarketplaceIds, setSelectedDeliveryDayMarketplaceIds] = useState([]);

  const getCombinedOrderItems = () => {
    setCombinedOrderItems([]);
    if (!selectedDeliveryDayMarketplaceIds.length) {
      return;
    }

    setError(null);
    setLoading(true);
    apiCalls
      .getCombinedOrderItems({
        deliveryDayMarketplaceIds: selectedDeliveryDayMarketplaceIds.join(','),
      })
      .then((result) => {
        if (result.data && result.data.combinedOrderItems) {
          setCombinedOrderItems(result.data.combinedOrderItems);
        }
        setLoading(false);
      })
      .catch((errors) => {
        setError(utils.getErrorMessageFromResponse(errors));
        setLoading(false);
      });
  };

  const triggerDdmSelect = (selectedIndex, ddm) => {
    const newSelectedDdmIds = [...selectedDeliveryDayMarketplaceIds];
    if (selectedIndex > -1) {
      newSelectedDdmIds.splice(selectedIndex, 1);
    } else {
      newSelectedDdmIds.push(ddm.id);
    }
    setSelectedDeliveryDayMarketplaceIds(newSelectedDdmIds);
  };

  const getDdmRow = (ddm, index) => {
    const deliveryDate = utils.getFormattedDateFromString(ddm.deliveryDate, DATE_FORMAT.displayOnlyDate);

    const selectedIndex = selectedDeliveryDayMarketplaceIds.findIndex((sddm) => sddm === ddm.id);
    const isSelected = selectedIndex > -1;

    return (
      <tr key={index} onClick={() => triggerDdmSelect(selectedIndex, ddm)}>
        <th scope="row">
          <Link to={`${match.url}/delivery/${ddm.id}`}>#{ddm.id}</Link>
        </th>
        <td>{deliveryDate}</td>
        <td>
          <input
            name="selectDdm"
            type="checkbox"
            className="m-r-1"
            checked={isSelected}
            onChange={() => triggerDdmSelect(selectedIndex, ddm)}
          />
          <span className={isSelected ? '' : 'text-muted'} onClick={() => triggerDdmSelect(selectedIndex, ddm)}>
            <FormattedMessage id={'marketplace.admin.combined.orders.ddms.actions.select'} />
          </span>
        </td>
      </tr>
    );
  };

  return (
    <>
      <Loader show={loading} />
      <ErrorMessage error={error} />

      {combinedOrderItems.length ? (
        <div className="panel">
          <div className="panel__corner">
            <FontAwesomeIcon icon={faList} />
          </div>
          <h6 className="panel__title">
            <FormattedMessage id={'marketplace.admin.combined.orders.items.header'} />
          </h6>

          <table className="table table-striped admin__table">
            <thead>
              <tr>
                <th scope="col">
                  <FormattedMessage id={'marketplace.admin.combined.orders.items.id'} />
                </th>
                <th scope="col">
                  <FormattedMessage id={'marketplace.admin.combined.orders.items.name'} />
                </th>
                <th scope="col">
                  <FormattedMessage id={'marketplace.admin.combined.orders.items.quantity'} />
                </th>
                <th scope="col">
                  <FormattedMessage id={'marketplace.admin.combined.orders.items.total.sum'} />
                </th>
              </tr>
            </thead>
            <tbody>
              {combinedOrderItems.map((combinedOrderItem, index) => (
                <tr key={index}>
                  <td>
                    <Link to={`/marketplaceAdmin/${marketplace.id}/view?itemId=${combinedOrderItem.orderItem.item.id}`}>
                      {combinedOrderItem.orderItem.item.id}
                    </Link>
                  </td>
                  <td>
                    <Link to={`/item/${combinedOrderItem.orderItem.item.id}`}>
                      {combinedOrderItem.orderItem.itemName}
                    </Link>
                  </td>
                  <td>{combinedOrderItem.quantity}</td>
                  <td>{combinedOrderItem.totalSum}€</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        ''
      )}

      <div className="panel">
        <div className="panel__corner">
          <FontAwesomeIcon icon={faCalendar} />
        </div>
        <h6 className="panel__title">
          <FormattedMessage id={'marketplace.admin.combined.orders.ddms.header'} />
        </h6>

        <div className="m-b-6">
          <button className="btn btn-primary btn-small m-r-2" onClick={getCombinedOrderItems}>
            <FormattedMessage
              id={'marketplace.admin.combined.orders.ddms.generate.combined.items'}
              values={{ selectedSize: selectedDeliveryDayMarketplaceIds.length }}
            />
          </button>
          <button
            className="btn btn-default btn-small m-r-2"
            onClick={() => {
              setSelectedDeliveryDayMarketplaceIds([]);
              setCombinedOrderItems([]);
            }}
          >
            <FormattedMessage id={'marketplace.admin.combined.orders.ddms.reset.combined.items'} />
          </button>
        </div>

        <table className="table table-striped admin__table">
          <thead>
            <tr>
              <th scope="col">
                <FormattedMessage id={'marketplace.admin.combined.orders.ddms.table.id'} />
              </th>
              <th scope="col">
                <FormattedMessage id={'marketplace.admin.combined.orders.ddms.table.delivery.date'} />
              </th>
              <th scope="col">
                <FormattedMessage id={'marketplace.admin.combined.orders.ddms.table.actions'} />
              </th>
            </tr>
          </thead>
          <tbody>
            {deliveryDayMarketplaces.map((ddm, index) => getDdmRow(ddm, index))}
            <tr>
              <td colSpan={3} style={{ height: '60px' }}></td>
            </tr>
            {pastDeliveryDayMarketplaces.map((ddm, index) => getDdmRow(ddm, index))}
          </tbody>
        </table>
      </div>
    </>
  );
};

MarketplaceAdminCombinedOrderItems.propTypes = {
  deliveryDayMarketplaces: PropTypes.array.isRequired,
  pastDeliveryDayMarketplaces: PropTypes.array.isRequired,
};

MarketplaceAdminCombinedOrderItems.defaultProps = {};

function mapStateToProps(state) {
  return {
    marketplace: state.marketplace.marketplace,
  };
}

export default withRouter(connect(mapStateToProps)(MarketplaceAdminCombinedOrderItems));
